import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { ClientsSessionService } from '@shared/services/client-session.service';  
import { AppConstant } from '@app/configs/app.constant';
import { ModuleUrlBuilder } from './../../../utils/module-url.util'; 
import { CheckCompanyCanUserServiceRequest, ResultCheckCompanyCanUserService, ServiceInfo } from '@app/core/models/manage-service.model';
import { ManageService } from '@app/core/services/manage-service.service';
import { AlertService } from '@app/core/services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { UserManagementService } from '@app/core/services/user-management.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { modulesConfig } from '@app/configs/module.config';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  IModuleConfig,
  IExternalLinkConfig,
  ModuleType,
  ModuleCode
} from '@app/core/models/project-config.model';
import { ProjectConfigService } from '@app/core/services/project-config.service';
const moduleUtil = new ModuleUrlBuilder(new ClientsSessionService());
@Component({
  selector: 'app-print-and-post-button',
  templateUrl: './print-and-post-button.component.html',
  styleUrls: ['./print-and-post-button.component.css']
})
export class PrintAndPostButtonComponent implements OnInit {
  public isDesktop: boolean = false;
  public externalLinkConfig: IExternalLinkConfig;
  private serviceInfo: ServiceInfo[];
  constructor(
    private router: Router,
    private manageService: ManageService,
    private projectConfigService: ProjectConfigService,
    private alertService: AlertService,
    public translate: TranslateService,
    private clientService: ClientsSessionService,
    private userManagementService: UserManagementService,
    private permissionsService: NgxPermissionsService,
    private deviceService: DeviceDetectorService,
  ){
    if(this.deviceService.getDeviceInfo().deviceType == 'desktop'){
      this.isDesktop = true;
    } 
    this.permissionsService.flushPermissions();
    this.clientService.init(); 
  }

  ngOnInit(): void {
    this.permissionsService.loadPermissions(
      this.clientService.getPermissions()
    ); 
    this.fetchExternalLinkConfig();
    this.getService(); 
   
}

  goToPrintAndPost(){ 
     this.checkServiceCode(ModuleCode.PrintAndPost, 'Print and Post', true, false, moduleUtil.printAndPost, null)   
  }

  getService() {
    this.manageService.listService().subscribe({next: (v) => {
      this.serviceInfo = v.data.result;
    }, error:(e)=>{

    }})
  }

  fetchExternalLinkConfig() {
    this.projectConfigService.externalLinkConfig().subscribe({
      next: (v) => {
        if (v.code == AppConstant.HTTP_STATUS_CODE_SUCCESS) {
          sessionStorage.setItem("externalLink",JSON.stringify(v.data));
          this.externalLinkConfig = v.data;
        } else {
          console.log(v.message);
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  async checkServiceCode(serviceCode: string, moduleName : string, external: boolean, useApiConfigValue: boolean, urlPath: string, withQueryParams: string){
    const canUserService = await this.checkIdentity(serviceCode);      
    if(!canUserService.can) {
      if(canUserService.selfService){
        this.alertService.warningKYC(this.translate.instant('KYC.Please KYC on mobile'),this.translate.instant('KYC.Warning KYC'))
      } else { 
        this.alertService.confirm(this.translate.instant('KYC.ServiceRequireAlert', {moduleName : moduleName}),this.translate.instant('KYC.Please KYC'))
        .then((confirm)=> {                    
          if(confirm.value){
            this.router.navigate(["/mainmenu/kyc"], { state: {identity: canUserService.requireIdentityTypeIdList}});
          }
        });
      }

      return ;
    } else {      
      const moduleFilter = modulesConfig.filter((element) => element.code == serviceCode);
      const checkPermission = await this.permissionsService.hasPermission(moduleFilter[0].permissions!);      
      if(!checkPermission){
       this.alertService.error(this.translate.instant('notHavePermission'));
       return; 
      }

      await this.getListPermission();        
    } 
    switch (external) {
      case false:
        this.onInternalModule(urlPath, withQueryParams);
        break;
      case true:
        if(this.deviceService.getDeviceInfo().browser == 'Safari' && this.deviceService.getDeviceInfo().deviceType !== 'desktop') this.onInternalModuleForSafari(urlPath, useApiConfigValue); 
        else this.onExternalModule(urlPath, useApiConfigValue);        
        break;
      default:
        throw new Error(this.translate.instant('KYC.Module not implemented.'));
    }
    // 
  }

  onInternalModule(routePath: string, withQueryParams: string) {
    const dom: any = document.querySelector("body");    
    if(dom.classList.contains('menuleft-hide')){
      dom.classList.toggle("menuleft-hide");
    }
    if(withQueryParams) this.router.navigate([routePath], { queryParams: { [withQueryParams] : 'Y'}});
    else this.router.navigate([routePath]);
  }

  onExternalModule(urlPath: string, useApiConfigValue: boolean) { 
    if (useApiConfigValue) {
      urlPath = this.externalLinkConfig[urlPath];  
    }    
      window.open(urlPath, '_blank');       
  }

  onInternalModuleForSafari(urlPath: string, useApiConfigValue: boolean){
    if (useApiConfigValue) {
      urlPath = this.externalLinkConfig[urlPath];  
    }
      window.open(urlPath, '_self');  
  }
  
  checkIdentity(serviceCode: string) : Promise<ResultCheckCompanyCanUserService>{ 
    return new Promise((resolve) => { 
      let serviceFileter = this.serviceInfo.filter((service) => service.serviceCode == serviceCode);
      if(serviceFileter.length == 0) return this.alertService.error(this.translate.instant("KYC.Not found service"));
      const serviceID = serviceFileter[0].serviceId; 
      let checkCompanyCanUserServiceRequest: CheckCompanyCanUserServiceRequest = {cpid: this.clientService.getCpid(), serviceId: serviceID};
      this.manageService.checkCompanyCanUseService(checkCompanyCanUserServiceRequest).subscribe({next:(v)=> {
        if(v.code === AppConstant.HTTP_STATUS_CODE_SUCCESS){
          resolve(v.data);
        }
      }, error:(e)=> {
          resolve(new ResultCheckCompanyCanUserService({can: false,requireIdentityTypeIdList: []}));
      }});
    });   
  }

  
  getListPermission() : Promise<boolean>{
    return new Promise((resolve) => {            
      this.userManagementService.getListPermission().subscribe({next:(v)=> {
        if(v.code === AppConstant.HTTP_STATUS_CODE_SUCCESS){
          let currentUser = JSON.parse(
            sessionStorage.getItem("currentUser") || "{}"
          );          
          currentUser['permissions'] = v.data
          sessionStorage.setItem("currentUser",JSON.stringify(currentUser));

          resolve(true);
        }
      }, error:(e)=> {
          resolve(true);
      }});
    });      
  }

  openNewTabSafari(url) {  
    var a = document.createElement("a");    
    a.href = url;    
    a.setAttribute('target', '_blank');    
    var event = new MouseEvent("click", {
      bubbles: true,
      cancelable: false,
      view: window
    });    
    a.dispatchEvent(event);
  }
  
}
